module.exports = __webpack_public_path__ + "word_map.925633f6715929c667b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/word_map.png
// module id = 1047
// module chunks = 2